const thumbs = document.querySelectorAll('.thumb');
const gallerySlides = document.querySelectorAll('[data-gallery-slide]');
const galleryViewport = document.querySelector('[data-gallery-viewport]');
const galleryCurrent = document.querySelector('#gallery-current');
const galleryPrevious = document.querySelector('[data-gallery-prev]');
const galleryNext = document.querySelector('[data-gallery-next]');
const galleryHint = document.querySelector('.gallery__mobile-hint');
let activeGalleryIndex = 0;
let galleryPointerStart = null;

function showGallerySlide(index, focusThumb = false) {
  const normalizedIndex = (index + gallerySlides.length) % gallerySlides.length;
  activeGalleryIndex = normalizedIndex;
  thumbs.forEach((thumb, thumbIndex) => {
    const isActive = thumbIndex === normalizedIndex;
    thumb.classList.toggle('is-active', isActive);
    thumb.setAttribute('aria-selected', String(isActive));
    thumb.tabIndex = isActive ? 0 : -1;
  });
  gallerySlides.forEach((slide, slideIndex) => {
    const isActive = slideIndex === normalizedIndex;
    slide.classList.toggle('is-active', isActive);
    slide.setAttribute('aria-hidden', String(!isActive));
  });
  galleryCurrent.textContent = String(normalizedIndex + 1).padStart(2, '0');
  if (galleryHint) galleryHint.hidden = normalizedIndex !== 0;
  if (focusThumb) thumbs[normalizedIndex].focus();
}

thumbs.forEach((thumb, index) => {
  thumb.addEventListener('click', () => {
    showGallerySlide(index);
  });

  thumb.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
    event.preventDefault();
    const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
    showGallerySlide(index + direction, true);
  });
});

if (galleryPrevious && galleryNext) {
  galleryPrevious.addEventListener('click', () => showGallerySlide(activeGalleryIndex - 1));
  galleryNext.addEventListener('click', () => showGallerySlide(activeGalleryIndex + 1));
}

if (galleryViewport) {
  galleryViewport.addEventListener('pointerdown', (event) => {
    galleryPointerStart = event.clientX;
  });
  galleryViewport.addEventListener('pointerup', (event) => {
    if (galleryPointerStart === null) return;
    const distance = event.clientX - galleryPointerStart;
    galleryPointerStart = null;
    if (Math.abs(distance) < 45) return;
    showGallerySlide(activeGalleryIndex + (distance < 0 ? 1 : -1));
  });
}

showGallerySlide(0);

const buyOptions = document.querySelectorAll('.buy-option');
const offerPrice = document.querySelector('#offer-price');
const offerCompare = document.querySelector('#offer-compare');
const offerSaving = document.querySelector('#offer-saving');
const offerCta = document.querySelector('#offer-cta');
const offerCtaPrice = document.querySelector('#offer-cta-price');
const mobileBuyPrice = document.querySelector('.mobile-buy b');

buyOptions.forEach((option, index) => {
  option.addEventListener('click', () => {
    buyOptions.forEach((item) => {
      item.classList.remove('is-selected');
      item.setAttribute('aria-checked', 'false');
    });
    option.classList.add('is-selected');
    option.setAttribute('aria-checked', 'true');
    offerPrice.textContent = option.dataset.price;
    offerCompare.textContent = option.dataset.compare;
    offerSaving.textContent = option.dataset.saving;
    offerCta.href = option.dataset.href;
    offerCta.querySelector('span').textContent = `Zamów ${option.dataset.quantity} × NoomEMS`;
    offerCtaPrice.textContent = option.dataset.price;
    if (mobileBuyPrice) mobileBuyPrice.textContent = option.dataset.price;
  });

  option.addEventListener('keydown', (event) => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
    event.preventDefault();
    const direction = ['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1;
    const nextIndex = (index + direction + buyOptions.length) % buyOptions.length;
    buyOptions[nextIndex].focus();
    buyOptions[nextIndex].click();
  });
});

const mobileBuy = document.querySelector('.mobile-buy');
const stickyQuietZones = document.querySelectorAll('.offer, .faq');

if (mobileBuy && stickyQuietZones.length && 'IntersectionObserver' in window) {
  const visibleQuietZones = new Set();
  const stickyObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) visibleQuietZones.add(entry.target);
      else visibleQuietZones.delete(entry.target);
    });
    mobileBuy.classList.toggle('is-context-hidden', visibleQuietZones.size > 0);
  }, { threshold: 0.08 });

  stickyQuietZones.forEach((zone) => stickyObserver.observe(zone));
}

const carouselRoot = document.querySelector('[data-reviews-carousel]');

if (carouselRoot) {
  const viewport = carouselRoot.querySelector('[data-carousel-viewport]');
  const track = carouselRoot.querySelector('[data-carousel-track]');
  const originalSlides = [...carouselRoot.querySelectorAll('[data-carousel-slide]')];
  const dotsRoot = carouselRoot.querySelector('[data-carousel-dots]');
  const status = carouselRoot.querySelector('[data-carousel-status]');
  const previousButton = carouselRoot.querySelector('[data-carousel-prev]');
  const nextButton = carouselRoot.querySelector('[data-carousel-next]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const slideCount = originalSlides.length;
  let current = 1;
  let timer;
  let pointerStart = null;
  let isResetting = false;

  const firstClone = originalSlides[0].cloneNode(true);
  const lastClone = originalSlides[slideCount - 1].cloneNode(true);
  firstClone.dataset.carouselClone = 'true';
  lastClone.dataset.carouselClone = 'true';
  firstClone.setAttribute('aria-hidden', 'true');
  lastClone.setAttribute('aria-hidden', 'true');
  track.prepend(lastClone);
  track.append(firstClone);

  const slides = [...track.children];
  const dots = originalSlides.map((_, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'reviews-carousel__dot';
    dot.setAttribute('aria-label', `Pokaż opinię ${index + 1}`);
    dot.addEventListener('click', () => goTo(index + 1));
    dotsRoot.append(dot);
    return dot;
  });

  const logicalIndex = () => {
    if (current === 0) return slideCount - 1;
    if (current === slideCount + 1) return 0;
    return current - 1;
  };

  const positionTrack = (animate = true) => {
    const activeSlide = slides[current];
    if (!activeSlide) return;
    const viewportWidth = viewport.getBoundingClientRect().width;
    const slideWidth = activeSlide.getBoundingClientRect().width;
    const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
    const offset = viewportWidth / 2 - slideWidth / 2 - current * (slideWidth + gap);
    track.style.transition = animate && !reduceMotion ? '' : 'none';
    track.style.transform = `translate3d(${offset}px, 0, 0)`;
    slides.forEach((slide, index) => {
      const isActive = index === current;
      slide.classList.toggle('is-active', isActive);
      if (!slide.dataset.carouselClone) slide.setAttribute('aria-hidden', String(!isActive));
    });
    const activeDot = logicalIndex();
    dots.forEach((dot, index) => {
      const isActive = index === activeDot;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
    status.textContent = `Opinia ${activeDot + 1} z ${slideCount}`;
  };

  const normalizeLoop = () => {
    if (isResetting) return;
    if (current === 0 || current === slideCount + 1) {
      isResetting = true;
      current = current === 0 ? slideCount : 1;
      positionTrack(false);
      requestAnimationFrame(() => {
        track.style.transition = '';
        isResetting = false;
      });
    }
  };

  const restartTimer = () => {
    window.clearInterval(timer);
    if (!reduceMotion) timer = window.setInterval(() => goTo(current + 1, false), 5600);
  };

  function goTo(index, restart = true) {
    if (isResetting) return;
    current = index;
    positionTrack(true);
    if (restart) restartTimer();
  }

  previousButton.addEventListener('click', () => goTo(current - 1));
  nextButton.addEventListener('click', () => goTo(current + 1));
  track.addEventListener('transitionend', normalizeLoop);
  viewport.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') goTo(current - 1);
    if (event.key === 'ArrowRight') goTo(current + 1);
  });
  viewport.addEventListener('pointerdown', (event) => {
    pointerStart = event.clientX;
  });
  viewport.addEventListener('pointerup', (event) => {
    if (pointerStart === null) return;
    const distance = event.clientX - pointerStart;
    pointerStart = null;
    if (Math.abs(distance) < 45) return;
    goTo(current + (distance < 0 ? 1 : -1));
  });
  carouselRoot.addEventListener('mouseenter', () => window.clearInterval(timer));
  carouselRoot.addEventListener('mouseleave', restartTimer);
  carouselRoot.addEventListener('focusin', () => window.clearInterval(timer));
  carouselRoot.addEventListener('focusout', restartTimer);
  window.addEventListener('resize', () => positionTrack(false));

  positionTrack(false);
  restartTimer();
}
